import React from 'react'

const Offer = () => (
  <svg width="18" height="18" viewBox="0 0 18 18">
    <defs>
      <path
        id="9wm0a"
        d="M378.784 259.624a3.078 3.078 0 0 1-3.071 3.068h-7.321a3.078 3.078 0 0 1-3.071-3.068v-6.587l-1.52 1.533a.469.469 0 0 1-.665-.66l8.43-8.501a.469.469 0 0 1 .66-.004l6.319 6.22a.47.47 0 0 1 .175.174l2.14 2.107a.469.469 0 0 1-.657.668l-1.42-1.398zm-12.526 0a2.14 2.14 0 0 0 2.134 2.132h7.321a2.14 2.14 0 0 0 2.134-2.132v-7.37l-5.945-5.854-5.644 5.692zm5.778.78a4.466 4.466 0 1 1 0-8.932 4.466 4.466 0 0 1 0 8.931zm.005-1.655a2.814 2.814 0 0 0 2.816-2.811 2.814 2.814 0 0 0-2.816-2.812 2.814 2.814 0 0 0-2.817 2.812 2.814 2.814 0 0 0 2.817 2.811z"
      />
    </defs>
    <g>
      <g transform="translate(-363 -245)">
        <use fill="#4a4a4a" href="#9wm0a" />
      </g>
    </g>
  </svg>
)

export default Offer
